<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "logout",
  methods: {
    ...mapActions(["actionSetToken", "actionSetUser"])
  },
  mounted() {
    this.actionSetUser("actionSetUser", {});
    this.actionSetToken("actionSetToken", null);
    
    if (this.$msal&&this.$msal.isAuthenticated()) {
      this.$msal.signOut();
    }

    if (window.localStorage) {
      // window.localStorage.setItem("ccrs_user", "null");
      // window.localStorage.setItem("ccrs_token", "null");
      // window.localStorage.clear();
       this.$helper.removeStorageItem("ccrs_user");
       this.$helper.removeStorageItem("ccrs_token");
    }

    // Clear all cookies
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name +
        "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" +
        location.host;
    }

    // // Go to Login
    this.$router.push("/login");
  }
};
</script>
